export default __webpack_public_path__ + "static/media/wtwe-do.9491558e.png";